(() => {
  let o = (e) => {
      let t = e.closest(".media, .swiper-slide");
      if (!t) return !1;
      t = t.querySelector(".slideshow__video-cover");
      return !!(t && "none" !== t.style.display);
    },
    l = (e) => {
      var t = e.querySelectorAll(".slideshow__video video");
      e.swiper && e.swiper.initialized
        ? t.forEach((e) => {
            o(e)
              ? e.pause()
              : e.closest(".swiper-slide-visible")
                ? e.play()
                : e.pause();
          })
        : e.closest('[data-slide-count="1"]') &&
          t.forEach((e) => {
            o(e) ? e.pause() : e.play();
          });
    },
    c = (e) => {
      (e || document)
        .querySelectorAll(".slideshow__video-play-btn")
        .forEach((e) => {
          if (e.dataset.initialized) return;
          e.dataset.initialized = "true";
          e.addEventListener("click", function (n) {
            n.preventDefault();
            n.stopPropagation();
            var t = e.closest(".slideshow__video-cover");
            if (!t) return;
            var i = t.closest(".slideshow__video");
            if (!i) return;
            var s = t.getAttribute("data-play-url");
            if (s) {
              var r = i.querySelector(".slideshow__iframe-container");
              if (!r) return;
              var a = document.createElement("iframe");
              ((a.src = s),
                a.setAttribute("frameborder", "0"),
                a.setAttribute(
                  "allow",
                  "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                ),
                a.setAttribute("allowfullscreen", ""),
                a.setAttribute("playsinline", ""),
                (a.style.pointerEvents = "auto"),
                (r.innerHTML = ""),
                r.appendChild(a),
                (r.style.display = ""),
                t.classList.add("is-hidden"),
                (t.style.display = "none"),
                (t.style.pointerEvents = "none"));
            } else {
              t.classList.add("is-hidden");
              t.style.display = "none";
              t.style.pointerEvents = "none";
              let e = i.querySelector("video");
              e && e.play().catch(() => {});
            }
          });
        });
    },
    n = (e, t) => {
      if (!e || !t || !e.pagination) return;
      let i =
          "true" === t.getAttribute("data-autoplay") &&
          e.autoplay &&
          e.autoplay.running,
        o =
          Number(
            e.slides["number" == typeof e.activeIndex ? e.activeIndex : 0]
              ?.dataset?.swiperAutoplay,
          ) ||
          Number(t.getAttribute("data-slide-duration")) ||
          5e3,
        s = Array.from(
          e.pagination.el
            ? e.pagination.el.querySelectorAll(
                ".swiper-pagination-bullet, .slideshow__bullet",
              )
            : [],
        ),
        r = "number" == typeof e.realIndex ? e.realIndex : e.activeIndex || 0;
      s.forEach((e) => {
        (e.classList.remove("is-autoplaying"),
          e.style.removeProperty("--slideshow-progress-duration"));
      });
      if (!i) return;
      let a = s[r];
      a &&
        (a.style.setProperty("--slideshow-progress-duration", `${o}ms`),
        a.offsetWidth,
        a.classList.add("is-autoplaying"));
    },
    t = (t) => {
      t &&
        t.classList.contains("section-slideshow") &&
        new IntersectionObserver((e, obs) => {
          e.forEach((r) => {
            if (r.isIntersecting) {
              // Swiper sadece bir kez kurulur; tekrar kurulum cift touch dinleyicisi birakip kaydirmayi bozuyordu.
              obs.disconnect();
              r = t.querySelector(".slideshow");
              if (r) {
                var a = r.querySelector(".swiper-button-prev"),
                  o = r.querySelector(".swiper-button-next"),
                  s = {
                    speed: 800,
                    autoHeight: !1,
                    allowTouchMove: !0,
                    mousewheel: { forceToAxis: !0 },
                    watchSlidesProgress: !0,
                    preventInteractionOnTransition: !0,
                    noSwiping: !0,
                    // Sadece oynat butonu kaydirmayi baslatmaz; video alani da tutup kaydirilabilir.
                    noSwipingSelector: ".slideshow__video-play-btn",
                    touchStartPreventDefault: !1,
                  };
                let i = (e) => {
                  var t =
                      window.innerWidth ||
                      document.documentElement.clientWidth ||
                      document.body.clientWidth,
                    r = e.activeIndex,
                    r = e.slides[r];
                  let i = 0,
                    a;
                  (e.el.parentNode.classList.contains(
                    "slideshow__swiper--simple",
                  ) && ((a = e.el.parentNode), (i = 990)),
                    (e.el.classList.contains("slideshow__swiper--overlay") ||
                      e.el.classList.contains("slideshow__swiper--grid")) &&
                      (i = 0));
                  e = [
                    e.navigation.nextEl,
                    e.navigation.prevEl,
                    e.pagination.el,
                    ...(a ? [a] : []),
                  ];
                  if (t >= i) {
                    let i = r.dataset.colorScheme;
                    e.forEach((t) => {
                      if (t) {
                        let e = t.getAttribute("class");
                        ((e = e.replace(/color-background-\d+/g, "")),
                          t.setAttribute("class", e),
                          t.classList.add(i));
                      }
                    });
                  } else
                    e.forEach((t) => {
                      if (t) {
                        let e = t.getAttribute("class");
                        ((e = e.replace(/color-background-\d+/g, "")),
                          t.setAttribute("class", e));
                      }
                    });
                };
                if (
                  ("true" === r.getAttribute("data-autoplay") &&
                    (s.autoplay = { disableOnInteraction: !0 }),
                  "true" === r.getAttribute("data-pagination") &&
                    (s.pagination = (() => {
                      let p = r.querySelector(".slideshow__pagination");
                      return {
                        el: p,
                        type: "bullets",
                        clickable: !0,
                        bulletClass: "slideshow__bullet",
                        bulletActiveClass: "slideshow__bullet--active",
                        renderBullet: (_, cls) =>
                          `<span class="${cls}">` +
                          `<svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">` +
                          `<circle class="svg__bg-circle" cx="14" cy="14" r="11" stroke-width="2"/>` +
                          `<circle class="svg__progress-circle" cx="14" cy="14" r="11" stroke-width="2"/>` +
                          `<circle class="svg__dot" cx="14" cy="14" r="3"/>` +
                          `</svg>` +
                          `</span>`,
                      };
                    })()),
                  "true" === r.getAttribute("data-navigation") &&
                    (s.navigation = { nextEl: o, prevEl: a }),
                  "true" === r.getAttribute("data-parallax") &&
                    "grid" !== r.getAttribute("data-layout") &&
                    (s.parallax = !0),
                  "true" === r.getAttribute("data-enable-loop") &&
                    (s.loop = !0),
                  "grid" === r.getAttribute("data-layout") &&
                    (s.breakpoints = { 750: { slidesPerView: "auto" } }),
                  1 < Number(r.getAttribute("data-slide-count")))
                )
                  if ("simple" === r.getAttribute("data-layout")) {
                    var o = r.querySelector(".slideshow__swiper--text");
                    let t = r.querySelector(".slideshow__swiper--media");
                    if (o && t) {
                      let e = new Swiper(o, s);
                      var a = new Swiper(t, {
                        ...s,
                        autoplay: !1,
                        pagination: !1,
                        navigation: !1,
                        parallax: !1,
                      });
                      (((e.controller.control = a).controller.control = e),
                        i(e),
                        n(e, r),
                        e.on("beforeTransitionStart", function () {
                          i(this);
                        }),
                        e.on("slideChangeTransitionStart", function () {
                          n(this, r);
                        }),
                        e.on("autoplayStart", function () {
                          n(this, r);
                        }),
                        e.on("autoplayStop", function () {
                          n(this, r);
                        }),
                        a.on("beforeTransitionStart", function () {
                          i(e);
                        }),
                        a.on("slideChange", function () {
                          l(t);
                        }));
                    }
                  } else if ("overlay" === r.getAttribute("data-layout")) {
                    let e = r.querySelector(".slideshow__swiper--overlay");
                    e &&
                      ((o = new Swiper(e, {
                        ...s,
                        effect: "creative",
                        creativeEffect: {
                          prev: { translate: [0, 0, -400] },
                          next: { translate: ["100%", 0, 0] },
                        },
                      })),
                      i(o),
                      n(o, r),
                      o.on("beforeTransitionStart", function () {
                        i(this);
                      }),
                      o.on("slideChangeTransitionStart", function () {
                        n(this, r);
                      }),
                      o.on("autoplayStart", function () {
                        n(this, r);
                      }),
                      o.on("autoplayStop", function () {
                        n(this, r);
                      }),
                      o.on("slideChange", function () {
                        l(e);
                      }));
                  } else if ("grid" === r.getAttribute("data-layout")) {
                    let e = r.querySelector(".slideshow__swiper--grid");
                    e &&
                      ((a = new Swiper(e, s)),
                      i(a),
                      n(a, r),
                      a.on("beforeTransitionStart", function () {
                        i(this);
                      }),
                      a.on("slideChangeTransitionStart", function () {
                        n(this, r);
                      }),
                      a.on("autoplayStart", function () {
                        n(this, r);
                      }),
                      a.on("autoplayStop", function () {
                        n(this, r);
                      }),
                      a.on("slideChange", function () {
                        l(e);
                      }));
                  }
              }
            }
          });
        }).observe(t);
    },
    i = (e) => {
      if (e && e.classList.contains("section-slideshow")) {
        let i = e.querySelector(".slideshow"),
          r;
        (i && "simple" === i.getAttribute("data-layout")
          ? (r = e.querySelector(".slideshow__swiper--media"))
          : i && "overlay" === i.getAttribute("data-layout")
            ? (r = e.querySelector(".slideshow__swiper--overlay"))
            : i &&
              "grid" === i.getAttribute("data-layout") &&
              (r = e.querySelector(".slideshow__swiper--grid")),
          new IntersectionObserver((e) => {
            e.forEach((e) => {
              var t;
              e.isIntersecting
                ? r &&
                  (l(r), r.swiper) &&
                  "true" === i.getAttribute("data-autoplay") &&
                  r.swiper.autoplay.resume()
                : r &&
                  ((e = r),
                  (t = e.querySelectorAll(".slideshow__video video")),
                  e.swiper && e.swiper.initialized
                    ? t.forEach((e) => {
                        e.pause();
                      })
                    : e.closest('[data-slide-count="1"]') &&
                      t.forEach((e) => {
                        e.play();
                      }),
                  r.swiper) &&
                  "true" === i.getAttribute("data-autoplay") &&
                  r.swiper.autoplay.pause();
            });
          }).observe(e));
      }
    },
    // Dokunmatik cihazlarda YouTube iframe'i pointer-events: none (kaydirma icin, bkz. section CSS).
    // Video alanina dokunmak oynat/duraklat yapar (embed'de enablejsapi=1 var).
    y = (e) => {
      if (!window.matchMedia("(hover: none) and (pointer: coarse)").matches)
        return;
      (e || document)
        .querySelectorAll(".slideshow__iframe-container")
        .forEach((box) => {
          if (box.dataset.ytTapInit) return;
          box.dataset.ytTapInit = "true";
          box.addEventListener("click", () => {
            const iframe = box.querySelector("iframe");
            if (!iframe || !iframe.contentWindow) return;
            const playing =
              (box.dataset.ytPlaying ??
                String(/[?&]autoplay=1/.test(iframe.src))) === "true";
            iframe.contentWindow.postMessage(
              JSON.stringify({
                event: "command",
                func: playing ? "pauseVideo" : "playVideo",
                args: [],
              }),
              "*",
            );
            box.dataset.ytPlaying = String(!playing);
          });
        });
    };
  (t(document.currentScript.parentElement),
    c(document.currentScript.parentElement),
    i(document.currentScript.parentElement),
    y(document.currentScript.parentElement),
    document.addEventListener("shopify:section:load", function (e) {
      (t(e.target), c(e.target), i(e.target), y(e.target));
    }));
})();
